import {
    AnalyticsAttributesProvider,
    Markdown,
    useAnalytics
} from "../../components";
import { UiValuePropModel } from "../../models";
import { renderViewModel } from "../../render-view-model";

import { ValueProp, ValuePropLink } from "./UiValueProp.styles";

export type UiValuePropProps = {
    readonly model: UiValuePropModel;
};

const UiValueProp = ({
    model: {
        id,
        type,
        content: { entryTitle, image, icon, content, appearance, link }
    }
}: UiValuePropProps) => {
    const { sendTrackEvent } = useAnalytics();

    const valueProp = (
        <AnalyticsAttributesProvider
            value={{
                eventContainer: type,
                labelEnglish: entryTitle
            }}
        >
            <ValueProp $image={image} $appearance={appearance}>
                {!image && icon && renderViewModel(icon)}
                <Markdown>{content}</Markdown>
            </ValueProp>
        </AnalyticsAttributesProvider>
    );

    if (!link?.content) return valueProp;

    return (
        <ValuePropLink
            onClick={() => {
                //get readable title from markdown
                const linkTitle = getStringFromMarkdown(content);

                sendTrackEvent("clickedUiValuePropLink", {
                    event: "clicked",
                    eventComponent: "link",
                    eventContainer: type,
                    label: linkTitle,
                    labelEnglish: entryTitle,
                    uuid: id,
                    href: link.content.path,
                    title: linkTitle
                });
            }}
            href={link.content.path}
            data-uuid={id}
        >
            {valueProp}
        </ValuePropLink>
    );
};

function getStringFromMarkdown(content?: string, maxLength = 50): string {
    if (!content) return "";

    //remove special characters
    const plainText = content.replace(/[^a-z0-9]/gi, " ");

    //remove extra spaces
    const words = plainText
        .split(" ")
        .filter((e) => e)
        .join(" ");

    //strip special characters
    return words.slice(0, maxLength);
}

export default UiValueProp;
